import { useState } from 'react';
import { Card, Typography } from 'antd';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import './index.scss';

// Makers, models, brands and categories are all optional images, and the API
// returns null for anything without one. Rendering <img src={null}> leaned on
// alt="" plus the card's background to hide the failure - it looked fine, but
// only by accident, and a screen reader got nothing. Drop the img entirely when
// there is nothing to show, so the name-on-tile is the deliberate fallback.
const ImageCard = ({ imageUrl, imageName, url, brand }) => {
  const [failedSrc, setFailedSrc] = useState(null);
  const showImage = Boolean(imageUrl) && failedSrc !== imageUrl;

  return (
    <Link to={url}>
      <Card className={`image-card ${brand ? 'brand-card' : ''}`} hoverable>
        {showImage && <img src={imageUrl} alt={imageName} onError={() => setFailedSrc(imageUrl)} />}
        <Typography.Title level={2} strong>
          {imageName}
        </Typography.Title>
      </Card>
    </Link>
  );
};

ImageCard.propTypes = {
  imageUrl: PropTypes.string,
  imageName: PropTypes.string,
  url: PropTypes.string,
  brand: PropTypes.bool,
};

export default ImageCard;
